'use client';

import { c as _c } from "react/compiler-runtime";
import { Radio } from '@common/components';
import { cn } from '@core/utils';
import type { DetailHomeGiftProductResponse } from '@generated/unauth';
import { useCallback, useRef } from 'react';
import CountUp from 'react-countup';
import { CartCount } from '@/app/donation/(private)/cart/_components/CartItems/CartCount';
import { formatOptionLabel } from '../../../../_utils/formatOptionLabel';
import { useGiftOption } from '../../_context/GiftOptionContext';
import { AddToCartButton } from '../AddToCartButton';
interface PrefillFormProps {
  productData?: DetailHomeGiftProductResponse;
  productNumber: string;
  className?: string;
}
export const PrefillForm = t0 => {
  const $ = _c(67);
  const {
    productData,
    productNumber,
    className
  } = t0;
  const {
    selectedOptions,
    noOptionQuantity,
    handleOptionSelect,
    handleQuantityChange,
    handleOptionDelete,
    setNoOptionQuantity,
    getCartOptions
  } = useGiftOption();
  let handleAllOptionsDelete;
  let handleAllQuantityChange;
  let hasOptions;
  let isAllRequiredOptionsSelected;
  let isSingleOptionGroup;
  let optionGroups;
  let selectedOptionText;
  let selectedQuantity;
  let t1;
  let totalPrice;
  if ($[0] !== handleOptionDelete || $[1] !== handleQuantityChange || $[2] !== noOptionQuantity || $[3] !== productData?.optionGroupInfoList || $[4] !== productData?.requiredDonationAmount || $[5] !== selectedOptions) {
    optionGroups = productData?.optionGroupInfoList ?? [];
    hasOptions = optionGroups.length > 0;
    const basePrice = productData?.requiredDonationAmount ?? 0;
    const requiredOptionGroups = optionGroups.filter(_temp);
    isAllRequiredOptionsSelected = hasOptions && requiredOptionGroups.every(g_0 => selectedOptions.has(g_0.optionGroupId ?? 0));
    let t2;
    bb0: {
      if (!isAllRequiredOptionsSelected) {
        t2 = null;
        break bb0;
      }
      const optionNames = [];
      optionGroups.forEach(group => {
        const selected = selectedOptions.get(group.optionGroupId ?? 0);
        if (selected) {
          const optionItem = group.optionItemInfoList?.find(item => item.optionItemId === selected.optionItemId);
          if (optionItem?.itemName) {
            optionNames.push(optionItem.itemName);
          }
        }
      });
      t2 = optionNames.join(" ");
    }
    selectedOptionText = t2;
    let t3;
    bb1: {
      if (!isAllRequiredOptionsSelected || optionGroups.length === 0) {
        t3 = 1;
        break bb1;
      }
      const firstGroupId = optionGroups[0]?.optionGroupId ?? 0;
      t3 = selectedOptions.get(firstGroupId)?.quantity ?? 1;
    }
    selectedQuantity = t3;
    let t4;
    bb2: {
      if (!hasOptions) {
        t4 = basePrice * noOptionQuantity;
        break bb2;
      }
      if (selectedOptions.size === 0) {
        t4 = basePrice;
        break bb2;
      }
      let total;
      let totalExtraPrice;
      if ($[16] !== selectedOptions) {
        totalExtraPrice = 0;
        selectedOptions.forEach(opt => {
          totalExtraPrice = totalExtraPrice + opt.extraPrice;
          totalExtraPrice;
        });
        $[16] = selectedOptions;
        $[17] = totalExtraPrice;
      } else {
        totalExtraPrice = $[17];
      }
      const qty = isAllRequiredOptionsSelected ? selectedQuantity : 1;
      total = (basePrice + totalExtraPrice) * qty;
      t4 = total;
    }
    totalPrice = t4;
    handleAllQuantityChange = quantity => {
      optionGroups.forEach(group_0 => {
        const groupId = group_0.optionGroupId ?? 0;
        if (selectedOptions.has(groupId)) {
          handleQuantityChange(groupId, quantity);
        }
      });
    };
    handleAllOptionsDelete = () => {
      optionGroups.forEach(group_1 => {
        const groupId_0 = group_1.optionGroupId ?? 0;
        handleOptionDelete(groupId_0);
      });
    };
    isSingleOptionGroup = optionGroups.length === 1;
    t1 = optionGroups.filter(_temp2).map(_temp3);
    $[0] = handleOptionDelete;
    $[1] = handleQuantityChange;
    $[2] = noOptionQuantity;
    $[3] = productData?.optionGroupInfoList;
    $[4] = productData?.requiredDonationAmount;
    $[5] = selectedOptions;
    $[6] = handleAllOptionsDelete;
    $[7] = handleAllQuantityChange;
    $[8] = hasOptions;
    $[9] = isAllRequiredOptionsSelected;
    $[10] = isSingleOptionGroup;
    $[11] = optionGroups;
    $[12] = selectedOptionText;
    $[13] = selectedQuantity;
    $[14] = t1;
    $[15] = totalPrice;
  } else {
    handleAllOptionsDelete = $[6];
    handleAllQuantityChange = $[7];
    hasOptions = $[8];
    isAllRequiredOptionsSelected = $[9];
    isSingleOptionGroup = $[10];
    optionGroups = $[11];
    selectedOptionText = $[12];
    selectedQuantity = $[13];
    t1 = $[14];
    totalPrice = $[15];
  }
  const requiredOptionGroupIds = t1;
  const optionSectionRef = useRef(null);
  let t2;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      optionSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    };
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  const scrollToOptionSection = t2;
  if (!productData) {
    return null;
  }
  let t3;
  if ($[19] !== className) {
    t3 = cn("flex flex-col gap-36", className);
    $[19] = className;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== hasOptions || $[22] !== noOptionQuantity || $[23] !== setNoOptionQuantity) {
    t4 = !hasOptions && <div className="flex items-center justify-between border-b border-Gray-200 py-16"><span className="font-400 text-Gray-700 typo-body4">수량</span><CartCount count={noOptionQuantity} onCountChange={setNoOptionQuantity} /></div>;
    $[21] = hasOptions;
    $[22] = noOptionQuantity;
    $[23] = setNoOptionQuantity;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== handleOptionSelect || $[26] !== isSingleOptionGroup || $[27] !== optionGroups || $[28] !== selectedOptions) {
    let t6;
    if ($[30] !== handleOptionSelect || $[31] !== isSingleOptionGroup || $[32] !== selectedOptions) {
      t6 = optionGroup => {
        const groupId_1 = optionGroup.optionGroupId ?? 0;
        const selectedInGroup = selectedOptions.get(groupId_1);
        return <div key={groupId_1} className="flex flex-col">{optionGroup.optionGroupName && <p className="flex items-center gap-4 pb-8 pt-16 font-500 text-Gray-600 typo-body4">{isSingleOptionGroup ? "\uC0C1\uD488\uC635\uC158 \uC120\uD0DD" : optionGroup.optionGroupName}{optionGroup.requiredYN && <span className="font-600 text-R-500">*</span>}</p>}<Radio.Group value={selectedInGroup?.optionItemId} onChange={selectedItemId => {
            const selectedItem = optionGroup.optionItemInfoList?.find(item_0 => item_0.optionItemId === selectedItemId);
            if (selectedItem && !selectedItem.displaySoldOutYN) {
              handleOptionSelect(groupId_1, selectedItemId as number, selectedItem.extraPrice ?? 0);
            }
          }} theme="black" className="flex flex-col">{optionGroup.optionItemInfoList?.map(optionItem_0 => {
              const itemId = optionItem_0.optionItemId ?? 0;
              const isSoldOut = optionItem_0.displaySoldOutYN ?? false;
              const displayLabel = formatOptionLabel(optionItem_0.itemName ?? "", {
                isSoldOut,
                extraPrice: optionItem_0.extraPrice
              });
              return <div key={itemId} className="flex items-center gap-16 border-b border-Gray-200 py-16"><button type="button" onClick={() => {
                  if (!isSoldOut) {
                    handleOptionSelect(groupId_1, itemId, optionItem_0.extraPrice ?? 0);
                  }
                }} disabled={isSoldOut} className={cn("flex flex-1 items-center", isSoldOut && "cursor-not-allowed opacity-50")}><Radio.Item value={itemId} className="pointer-events-none"><span className="flex-1 text-left font-400 text-Gray-700 typo-body4">{displayLabel}</span></Radio.Item></button></div>;
            })}</Radio.Group></div>;
      };
      $[30] = handleOptionSelect;
      $[31] = isSingleOptionGroup;
      $[32] = selectedOptions;
      $[33] = t6;
    } else {
      t6 = $[33];
    }
    t5 = optionGroups.map(t6);
    $[25] = handleOptionSelect;
    $[26] = isSingleOptionGroup;
    $[27] = optionGroups;
    $[28] = selectedOptions;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[34] !== handleAllOptionsDelete || $[35] !== handleAllQuantityChange || $[36] !== isAllRequiredOptionsSelected || $[37] !== selectedOptionText || $[38] !== selectedQuantity) {
    t6 = isAllRequiredOptionsSelected && selectedOptionText && <div className="flex flex-col items-center justify-center rounded-small bg-Gray-25 p-12"><div className="flex w-full items-center justify-between"><span className="font-400 text-Gray-800 typo-caption1">{selectedOptionText} / {selectedQuantity}개</span><CartCount count={selectedQuantity} onCountChange={handleAllQuantityChange} onDelete={handleAllOptionsDelete} /></div></div>;
    $[34] = handleAllOptionsDelete;
    $[35] = handleAllQuantityChange;
    $[36] = isAllRequiredOptionsSelected;
    $[37] = selectedOptionText;
    $[38] = selectedQuantity;
    $[39] = t6;
  } else {
    t6 = $[39];
  }
  let t7;
  if ($[40] !== t4 || $[41] !== t5 || $[42] !== t6) {
    t7 = <div ref={optionSectionRef} data-gift-option-section={true} className="flex flex-col gap-28">{t4}{t5}{t6}</div>;
    $[40] = t4;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
  } else {
    t7 = $[43];
  }
  let t8;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="font-600 text-Gray-900 typo-h6">기부금액</span>;
    $[44] = t8;
  } else {
    t8 = $[44];
  }
  let t9;
  if ($[45] !== totalPrice) {
    t9 = <CountUp preserveValue={true} end={totalPrice} duration={0.3} delay={0.2} />;
    $[45] = totalPrice;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  let t10;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span>원</span>;
    $[47] = t10;
  } else {
    t10 = $[47];
  }
  let t11;
  if ($[48] !== t9) {
    t11 = <div className="flex items-center justify-between">{t8}<span className="flex items-center gap-2 font-800 text-Gray-900 typo-h4">{t9}{t10}</span></div>;
    $[48] = t9;
    $[49] = t11;
  } else {
    t11 = $[49];
  }
  let t12;
  if ($[50] !== getCartOptions || $[51] !== optionGroups) {
    t12 = getCartOptions(optionGroups);
    $[50] = getCartOptions;
    $[51] = optionGroups;
    $[52] = t12;
  } else {
    t12 = $[52];
  }
  const t13 = hasOptions ? selectedQuantity : noOptionQuantity;
  let t14;
  if ($[53] !== hasOptions || $[54] !== productData || $[55] !== productNumber || $[56] !== requiredOptionGroupIds || $[57] !== t12 || $[58] !== t13) {
    t14 = <AddToCartButton productInfo={productData} productNumber={productNumber} selectedOptions={t12} hasOptions={hasOptions} quantity={t13} requiredOptionGroupIds={requiredOptionGroupIds} theme="primary-fill" onOptionNotSelected={scrollToOptionSection} />;
    $[53] = hasOptions;
    $[54] = productData;
    $[55] = productNumber;
    $[56] = requiredOptionGroupIds;
    $[57] = t12;
    $[58] = t13;
    $[59] = t14;
  } else {
    t14 = $[59];
  }
  let t15;
  if ($[60] !== t11 || $[61] !== t14) {
    t15 = <div className="flex flex-col gap-24 mobile:hidden tablet:hidden">{t11}{t14}</div>;
    $[60] = t11;
    $[61] = t14;
    $[62] = t15;
  } else {
    t15 = $[62];
  }
  let t16;
  if ($[63] !== t15 || $[64] !== t3 || $[65] !== t7) {
    t16 = <form onSubmit={_temp4} className={t3}>{t7}{t15}</form>;
    $[63] = t15;
    $[64] = t3;
    $[65] = t7;
    $[66] = t16;
  } else {
    t16 = $[66];
  }
  return t16;
};
function _temp(g) {
  return g.requiredYN;
}
function _temp2(g_1) {
  return g_1.requiredYN;
}
function _temp3(g_2) {
  return g_2.optionGroupId;
}
function _temp4(e) {
  e.preventDefault();
}